import type {
    ClearCommerceCheckoutCustomerDetailsRequest,
    ClearCommerceCheckoutCustomerDetailsResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";

export const clearCommerceCheckoutCustomerDetailsOperation = defineCommerceOperation<
    ClearCommerceCheckoutCustomerDetailsRequest,
    ClearCommerceCheckoutCustomerDetailsResponse
>("commerce.checkout.customer-details.clear");
